const mutations = {
  SET_REPORTS: (state, data) => (state.reports = data),
  SET_REPORTS_LIST: (state, data) => (state.report_list = data)
}
export default mutations
